<template>
  <form>
    <fieldset class="uk-fieldset">
      <span class="uk-text-danger">{{ $attrs.formIssue }}</span>

      <div class="uk-margin">
        <input
          class="uk-input"
          type="text"
          placeholder="Todo Name"
          aria-label="Input"
          v-model="todo.name"
          @change="inputOnChange"
          autofocus
        />
      </div>
      <div class="uk-margin">
        <input
          class="uk-input"
          type="text"
          placeholder="Category"
          aria-label="Input"
          v-model="todo.category"
          @change="inputOnChange"
        />
      </div>
    </fieldset>
  </form>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      todo: {
        id: 0,
        name: "",
        category: "",
      },
    };
  },
  props: {
    modalOpen: Boolean,
  },
  methods: {
    inputOnChange() {
      this.$emit("inputChildData", this.todo);
    },
  },
  watch: {
    modalOpen: function () {
      if (!this.modalOpen) {
        this.todo.name = "";
        this.todo.category = "";
      }
    },
  },
});
</script>

<style></style>
